import styled from 'styled-components';

export const Container = styled.div`
  padding-bottom: ${props => props.theme.spacing(10)};
  & > div {
    overflow: unset !important;
  }
  & img {
    max-height: 100%;
  }
`;

export const TextContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 50%;
  width: 100%;
  height: 100%;
  color: ${props => props.theme.palette['white']};
  & > .resizer {
    height: 100%;
    width: 4px;
    background-color: ${props => props.theme.palette['white']};
    &:hover {
      cursor: ew-resize;
    }
  }
  & > .guide-text {
    min-width: 200px;
    transform: translateX(calc(-50% + 2px));
    margin-top: ${props => props.theme.spacing(2)};
    & > svg {
      transform: rotate(180deg);
    }
    & > p {
      color: rgba(255, 255, 255, 0.7);
    }
  }
`;
